export default class Accordion {
	constructor() {

		this.buttons = document.querySelectorAll('[data-accordion-button]');

		if (!this.buttons) {
			return;
		}

		this.buttons.forEach((button) => {

			button.addEventListener('click', () => {
				const accordionContent = button.nextElementSibling;
				const accordionItem = button.offsetParent;

				accordionContent.classList.toggle('is-active');
				accordionItem.classList.toggle('is-extended');

				if(accordionContent.classList.contains('is-active')) {
					accordionContent.style.height = accordionContent.scrollHeight + 'px';

					button.setAttribute('aria-expanded', true);
					accordionContent.setAttribute('aria-hidden', false);

				} else {
					accordionContent.style.height = 0;

					button.setAttribute('aria-expanded', false);
					accordionContent.setAttribute('aria-hidden', true);
				}
			});

		});
	}
}


